import { render, staticRenderFns } from "./deductionDropdown.vue?vue&type=template&id=2a85bf02&scoped=true"
import script from "./deductionDropdown.vue?vue&type=script&lang=js"
export * from "./deductionDropdown.vue?vue&type=script&lang=js"
import style0 from "./deductionDropdown.vue?vue&type=style&index=0&id=2a85bf02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85bf02",
  null
  
)

export default component.exports